<template>
    <div 
        v-if="shown" 
        id="unsubscribe" 
        style="margin-bottom:50px;margin-left:50px;margin-right:50px;margin-top:50px;text-align:center;"
    >
        <span style="font-family:arial,helvetica,sans-serif;font-size:12px;">
            Чтобы отписаться от этой рассылки, перейдите по 
            <a 
                :href="link"
                style="color:#46a8c6;"
                target="_blank"
                @click.stop.prevent=""
            >ссылке</a>
        </span>
    </div>
    <div v-else />
</template>

<script>
    export default {
        name: 'UnsubscribeDefault',
        props: {
            link: {
                'type': String,
                'default': '',
            },
            shown: {
                'type': Boolean,
                'default': true
            }
        }
    }
</script>

